export enum EFormMode {
  READ = 'read',
  CREATE = 'create',
  EDIT = 'edit',
}
